import { render, staticRenderFns } from "./curriculumList.vue?vue&type=template&id=bba21bce&scoped=true&"
import script from "./curriculumList.vue?vue&type=script&lang=js&"
export * from "./curriculumList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bba21bce",
  null
  
)

export default component.exports